import { SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS } from './globalPolicyDecisionRequestActionTypes';

export const setPurchaseLicenseFlowGrantStatus = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS,
      payload,
    });
  };
};
